import { render, staticRenderFns } from "./StockListTransferOrders.vue?vue&type=template&id=d194783e"
import script from "./StockListTransferOrders.vue?vue&type=script&lang=js"
export * from "./StockListTransferOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports